import React from 'react';
import { useState, useRef } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Form, Stack, Row, Col, Button } from 'react-bootstrap';

import Alert from '../helper/Alert';
import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';

import { subject, email, requiredPhoneNo, requiresRadioOrganisationType, contactText } from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

const schema = yup.object().shape({
    subject: subject,
    email: email,
    phoneno: requiredPhoneNo,
    organisationType: requiresRadioOrganisationType,
    message: contactText,
});

function PublicContact() {
    const { request } = useRequest();

    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const formRef = useRef(null);
    const editorRef = useRef(null);

    const sendMail = async (values) => {
        setLoading(true);
        var data = { ...values };
        console.log(data);
        const result = await request("/SendContactMail", data);
        //const result = await request("/SendContactMail", { email: data.email, phoneno: data.phoneno, organisationType: data.organisationType, subject: data.subject, message: data.message });
        //let result = await request("/Operator/GetRegistration", { id: id });

        const json = result.data;

        setLoading(false);
        if (json.r == 1) {
            toast.success("Nachricht wurde erfolgreich versandt.");
            formRef.current.setFieldValue("subject", "");
            formRef.current.setFieldValue("message", "");
            setSubmitted(true);
        }
        else {
            setMessage(json.message);
        }
    }

    if (submitted) {
        return (
            <>
                <h1>Kontaktanfrage erfolgreich</h1>
                <p>Vielen Dank für Ihre Anfrage.</p>
                <p>Wir werden Ihre Anfrage schnellstmöglich bearbeiten und uns dann bei Ihnen melden.</p>
                <p>Ihr bovest Team</p>
            </>
        );
    }

    return (
        <Formik
            innerRef={(f) => (formRef.current = f)}
            validationSchema={schema}
            onSubmit={(values) => {
                //values.message = editorRef.current.getContent();
                sendMail(values);
            }}
            initialValues={{
                email: '',
                subject: '',
                phoneno: '',
                message: '',
                organisationType: "0"
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => {
                return (
                    <>
                        <h1>Kontakt</h1>
                        <Form noValidate onSubmit={handleSubmit}>
                            <Stack gap={2}>
                                {message && <Alert type="error" message={message} />}
                                <Form.Group as={Row} className="form-group" controlId="email">
                                    <Form.Label className="required" column md={4} lg={3}>E-Mail-Adresse</Form.Label>
                                    <Col>
                                        <Form.Control isInvalid={errors.email && touched.email} type="text" name="email" value={values.email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group" controlId="phoneno">
                                    <Form.Label className="required" column md={4} lg={3}>Telefonnr.</Form.Label>
                                    <Col>
                                        <Form.Control isInvalid={errors.phoneno && touched.phoneno} type="text" name="phoneno" value={values.phoneno} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.phoneno}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group" controlId="organisationType">
                                    <Form.Label className="required" column md={4} lg={3}>Organisation</Form.Label>
                                    <Col>
                                        <div className="d-flex flex-column flex-lg-row">
                                            <Form.Check isInvalid={errors.organisationType && touched.organisationType} type="radio" className="mr-5" id="radio-1" name="organisationType" label="Schule" value="1" onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Check isInvalid={errors.organisationType && touched.organisationType} type="radio" className="mr-5" id="radio-2" name="organisationType" label="Unternehmen" value="2" onBlur={handleBlur} onChange={handleChange} />
                                            <Form.Check isInvalid={errors.organisationType && touched.organisationType} type="radio" className="mr-5" id="radio-3" name="organisationType" label="Sonstige" value="3" onBlur={handleBlur} onChange={handleChange} />
                                        </div>
                                        <Form.Control.Feedback type="invalid" className="d-block">
                                            {(errors.organisationType && touched.organisationType) && errors.organisationType}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group" controlId="subject">
                                    <Form.Label className="required" column md={4} lg={3}>Betreff</Form.Label>
                                    <Col>
                                        <Form.Control isInvalid={errors.subject && touched.subject} type="text" name="subject" value={values.subject} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.subject}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="form-group" controlId="message">
                                    <Form.Label column md={4} lg={3}>Nachricht</Form.Label>
                                    <Col>
                                        <Form.Control isInvalid={errors.message && touched.message} as="textarea" rows="10" name="message" value={values.message} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.message}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>


                                <MandatoryFieldNotice />

                                <Row>
                                    <Col sm={6}>
                                        Bitte nehmen Sie auch unsere <a target="_blank" href="/datenschutz"><u>Datenschutzerklärung</u></a> zur Kenntnis.
                                    </Col>
                                    <Col sm={6} className="text-right">
                                        <Button disabled={loading} variant="secondary" type="submit">
                                            <i className="fa-solid fa-paper-plane mr-2"></i>Nachricht versenden
                                        </Button>
                                    </Col>
                                </Row>

                            </Stack>

                        </Form>
                    </>
                )
            }}
        </Formik>
    );
}

export default PublicContact;